/**
 * Fix for Dawn theme: vertical thumbnail slider (Position: Left).
 *
 * 1) Dawn's built-in SliderComponent only calculates horizontal scroll
 *    offsets (offsetLeft/scrollLeft). When the thumbnail list is a
 *    vertical column, that math breaks and the up/down arrows get
 *    stuck disabled and do nothing.
 * 2) Per design (Figma), only 4 thumbnails should be visible at a time;
 *    any extra thumbnails should be hidden and reachable by scrolling
 *    via the up/down arrows, like a proper slider.
 *
 * This script detects vertical thumbnail sliders, caps the visible
 * height to show a configurable number of thumbnails (default 4),
 * and wires up working up/down scroll behavior for the rest.
 */
(function () {
  var VISIBLE_THUMBNAILS = 4; // change this if design ever wants a different count

  function initVerticalThumbnailSlider(sliderComponent) {
    var list = sliderComponent.querySelector('ul[id^="Slider-Thumbnails-"]');
    var prevBtn = sliderComponent.querySelector('.slider-button--prev');
    var nextBtn = sliderComponent.querySelector('.slider-button--next');

    if (!list || !prevBtn || !nextBtn) return;

    var isVertical = window.getComputedStyle(list).flexDirection.indexOf('column') !== -1;
    if (!isVertical) return; // leave horizontal layouts to Dawn's default behavior

    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.offsetHeight > 0;
    });
    if (items.length < 2) return;

    var itemHeight = items[0].offsetHeight;
    var itemStep = items[1].offsetTop - items[0].offsetTop; // item height + gap
    var gap = itemStep - itemHeight;
    if (!itemStep) return;

    // Cap visible area to show only VISIBLE_THUMBNAILS items.
    var maxHeight = (itemHeight * VISIBLE_THUMBNAILS) + (gap * (VISIBLE_THUMBNAILS - 1));
    list.style.maxHeight = maxHeight + 'px';
    // 'hidden' (not 'auto') so mouse wheel / trackpad can't scroll it —
    // only the arrow buttons (which use scrollBy via JS) can move it.
    list.style.overflowY = 'hidden';
    list.style.scrollBehavior = 'smooth';

    function scrollStep(direction) {
      var step = parseInt(prevBtn.dataset.step || VISIBLE_THUMBNAILS, 10);
      list.scrollBy({ top: direction * step * itemStep, behavior: 'smooth' });
    }

    // Clone buttons to remove Dawn's existing (broken/stuck-disabled) listeners.
    var newPrev = prevBtn.cloneNode(true);
    var newNext = nextBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(newPrev, prevBtn);
    nextBtn.parentNode.replaceChild(newNext, nextBtn);
    newPrev.removeAttribute('disabled');
    newNext.removeAttribute('disabled');

    newPrev.addEventListener('click', function (e) {
      e.preventDefault();
      scrollStep(-1);
    });
    newNext.addEventListener('click', function (e) {
      e.preventDefault();
      scrollStep(1);
    });

    function updateArrowState() {
      var atTop = list.scrollTop <= 1;
      var atBottom = Math.ceil(list.scrollTop + list.clientHeight) >= list.scrollHeight - 1;
      newPrev.disabled = atTop;
      newNext.disabled = atBottom;
      // If everything fits within the visible area, hide arrows entirely
      var needsScroll = list.scrollHeight > list.clientHeight + 1;
      newPrev.style.display = needsScroll ? '' : 'none';
      newNext.style.display = needsScroll ? '' : 'none';
    }
    list.addEventListener('scroll', updateArrowState);
    updateArrowState();

    sliderComponent.dataset.verticalFixApplied = 'true';
  }

  function initAll() {
    document.querySelectorAll('slider-component.thumbnail-slider').forEach(function (sliderComponent) {
      if (sliderComponent.dataset.verticalFixApplied === 'true') return;
      initVerticalThumbnailSlider(sliderComponent);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // Recalculate on resize since thumbnail sizes are responsive
  window.addEventListener('resize', function () {
    document.querySelectorAll('slider-component.thumbnail-slider').forEach(function (sliderComponent) {
      sliderComponent.dataset.verticalFixApplied = 'false';
      initVerticalThumbnailSlider(sliderComponent);
    });
  });
})();